import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useCustomStyles = makeStyles(theme => ({
	noAnchorStyle: {
		cursor: "default",
		color: "inherit",
		textDecoration: "none",
		"&:hover": {
			textDecoration: "none"
		}
	},
	noUnderline: {
		textDecoration: "none"
	},
	hyperlink: {
		cursor: "pointer",
		color: colors.blue[700],
		"&:hover": {
			textDecoration: "underline"
		}
	},
	flexCol: {
		flexDirection: "column"
	},
	fullWidth: {
		width: "100%"
	},
	chatInputContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		padding: theme.spacing(2, 3),
		position: "relative"
	},
	primaryActionButton: {
		fontSize: "16px",
		fontWeight: 500,
		padding: 16,
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[400])
		}
	},
	secondaryActionButton: {
		fontSize: "16px",
		fontWeight: 500,
		padding: 16,
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[100]),
		boxShadow: "none",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[200])
		}
	},
	buttonAction: {
		fontSize: "14px",
		...ColorUtil.getBackgroundAndContrastColor(colors.green[500]),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.green[600])
		}
	},
	shortButtonAction: {
		fontSize: "14px",
		padding: theme.spacing(0.75, 3),
		...ColorUtil.getBackgroundAndContrastColor(colors.green[400]),
		color: colors.gray[0],
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.blue[600])
		}
	},
	inlineText: {
		textOverflow: "ellipsis",
		whiteSpace: "pre-wrap",
		overflow: "hidden",
		maxWidth: "100%",
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 1,
		flex: 1
	},
	scrollBar: {
		"&::-webkit-scrollbar": {
			width: "6px !important",
			height: "6px !important"
		},
		"&::-webkit-scrollbar-thumb": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		"&::-webkit-scrollbar-track": {
			background: "hsla(0, 0%, 100%, 0.1)"
		}
	},
	uppercase: {
		textTransform: "uppercase"
	},
	noTextTransform: {
		textTransform: "none"
	},
	cancelButton: {
		color: colors.gray[400],
		padding: 16
	},
	inputLabel: {
		fontSize: 15,
		fontWeight: "bolder"
	},
	formText: {
		color: colors.gray[500],
		fontSize: 14
	},
	reportTableBodyText: {
		"& p, span, td": {
			fontSize: "0.825rem",
			lineHeight: "18px"
		}
	},
	italicText: {
		fontStyle: "italic"
	},
	boldText: {
		fontWeight: "bold"
	},
	cursorPointer: {
		cursor: "pointer"
	},
	tableActionButton: {
		borderRadius: 3,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50])
	},
	copyIcon: {
		cursor: "pointer",
		padding: "2px",
		marginRight: "2px"
	},
	"@keyframes pulse": {
		"0%": {
			boxShadow: `0 0 0 0 ${colors.purple[600]}`
		},
		"70%": {
			boxShadow: "0 0 0 10px"
		},
		"100%": {
			boxShadow: "0 0 0 0"
		}
	},
	"@keyframes rotate": {
		"0%": { transform: "rotate(0deg)" },
		"100%": { transform: "rotate(360deg)" }
	},
	rotateAnimation: {
		animation: "$rotate 2s linear infinite"
	},
	primaryActionButtonPulseEffect: {
		animation: "$pulse 2s infinite",
		"&:hover": {
			animation: "none"
		}
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	}
}), {
	index: 1 // this attribute is necessary to ensure classes not being overriden
})

export default useCustomStyles
